export default __webpack_public_path__ + "33fb1a063489dd9e1bbfc9e1a6e7d832.svg";